import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const LinkChevronGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M7.19977 4L6.25977 4.94L9.3131 8L6.25977 11.06L7.19977 12L11.1998 8L7.19977 4Z"
        fill={fillColor}
      />
    </g>
  );
};

export const LinkChevronSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <LinkChevronGroup {...props} />
    </svg>
  );
};
